import { Autocomplete, type FilterOptionsState, TextField } from "@mui/material";
import React, { type ComponentProps } from "react";

import { ariaLabel } from "src/constants/app/aria-labels";
import { useFieldContext } from "src/hooks";

import { FormControl } from "../FormControl";

type Props<T extends { label: string }> = ComponentProps<typeof FormControl> & {
  placeholder?: string;
  options: Array<T>;
  openText?: string;
  closeText?: string;
  filterOptions?: (options: Array<T>, state: FilterOptionsState<T>) => Array<T>;
};

export const AutocompleteField = <T extends { label: string }>({
  label,
  placeholder,
  options,
  openText,
  closeText,
  filterOptions,
}: Props<T>) => {
  const field = useFieldContext<T | null>();

  return (
    <FormControl>
      <Autocomplete
        id={field.name}
        disablePortal
        noOptionsText={ariaLabel.noResults}
        clearText={ariaLabel.clearSelection}
        value={field.state.value}
        options={options}
        onChange={(_event, option) => field.handleChange(option)}
        getOptionLabel={(option) => option.label}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            error={field.state.meta.errors?.length > 0}
          />
        )}
        openText={openText}
        closeText={closeText}
        filterOptions={filterOptions}
      />
    </FormControl>
  );
};
